export default function Header() {
  return (
    <header>
      <h1>Jordan Ribera</h1>
    </header>
  )
}